import OneSignalReact from 'react-onesignal';
import logger from 'utils/logger';

export const sendTags = async (phoneNumber: string) => {
  // otherwise request failed.
  // "No user with this id found"
  setTimeout(() => {
    OneSignalReact.getUserId().then((id) => {
      logger.logDebug(`getUserId id: ${id}`, 'OneSignal');
      if (!id) return console.warn('no user id');
      OneSignalReact.setExternalUserId(phoneNumber).then(() => {
        logger.logDebug(`setExternal user: ${phoneNumber}`, 'OneSignal');
      });
      OneSignalReact.sendTag('client', phoneNumber)
        .then(() => {
          logger.logDebug(`sendTag user: ${phoneNumber}`, 'OneSignal');
        })
        .catch((err) => {
          logger.error(err, {id, phoneNumber});
        });
    });
  }, 5000);
};
